import { useTranslation } from "react-i18next";
import { ExternalLinkIcon } from "../../../Custom/ExternalLink";
import { Spacer } from "./Spacer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Credit = _ref => {
  let {
    credit,
    lastElement
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: credit.url,
      children: [t(credit.text), " ", /*#__PURE__*/_jsx(ExternalLinkIcon, {})]
    }, credit.url), !lastElement ? /*#__PURE__*/_jsx(Spacer, {}) : null]
  });
};